import React, { useEffect } from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Grid, Typography } from '@inplayer-org/inplayer-ui';
import { Formik, Field, FormikProps } from 'formik';

// utils
import map from 'lodash/map';
import JSONparse from 'utils/json-parse-safe';

// types
import RootState from 'ducks/RootState';

// actions
import {
  loadExternalAssets as loadExternalAssetsAction,
  LoadExternalAssetsParams,
} from 'ducks/merchantDucks/items/actions';

// components
import Select from 'components/Fields/Select';
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

const { Container, Cell } = Grid;

interface StateProps {
  externalAssets: { videos: Array<any> };
}

interface DispatchProps {
  loadExternalAssets: (params: LoadExternalAssetsParams) => any;
}

interface OwnProps {
  rawContent: string;
  onSubmit: (contentString: string, externalAssetId: string) => void;
  formId: string;
  isReadOnly: boolean;
  closePanel: () => void;
}

interface FormValues {
  embed_code: string;
}

const defaultValues: FormValues = {
  embed_code: '',
};

type Props = StateProps & DispatchProps & OwnProps;

const OoyalaContent = ({
  rawContent,
  onSubmit,
  formId,
  loadExternalAssets,
  externalAssets: { videos },
  isReadOnly,
  closePanel,
}: Props) => {
  const initialValues: FormValues = {
    ...defaultValues,
    ...JSONparse(rawContent).value,
  };

  useEffect(() => {
    loadExternalAssets({ type: 'ooyala' });
  }, []);

  const defaultOption = { displayName: 'Select video', disabled: true };
  const options = map(videos, (video) => ({ value: video.embed_code, displayName: video.name }));

  const handleSubmit = ({ embed_code }: FormValues) => {
    const selectedVideo = videos.find((video) => video.embed_code === embed_code);
    const contentString = JSON.stringify(selectedVideo);

    onSubmit(contentString, embed_code);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {({ values: { embed_code } }: FormikProps<FormValues>) => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Container columns={1} rowGap="1rem">
              <Cell width={1}>
                <Typography variant="p">Choose your video from this list:</Typography>
              </Cell>
              <Cell width={1}>
                <Field
                  tag="text_input_select_video"
                  name="embed_code"
                  value={embed_code}
                  component={Select}
                  defaultOption={defaultOption}
                  options={options}
                  disabled={isReadOnly}
                />
              </Cell>
            </Container>
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (state) => ({
  externalAssets: state.items.externalAssets,
});

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  loadExternalAssets: loadExternalAssetsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(OoyalaContent);
